/* ============================================================
   Trendout — product.js
   Gallery (thumb rail / swipe carousel / zoom / lightbox),
   variants, quantity + live total, add-to-cart morph, sticky
   ATC bars, frequently-bought-together maths, review filters,
   size-guide highlight, related products, delivery estimate.
   Depends on main.js (window.Trendout).
   ============================================================ */
(function () {
  'use strict';

  var T = window.Trendout;
  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };

  var main = $('[data-gallery-main]');
  if (!main) return;

  /* Product data comes from the JSON block that snippets/trendout-buy-box.liquid
     renders. The static build hardcoded a title, price and image here. */
  var DATA = { variants: [], optionPositions: { color: null, size: null }, lowStockThreshold: 5 };
  var dataEl = $('[data-trendout-variants]');
  if (dataEl) {
    try { DATA = JSON.parse(dataEl.textContent); } catch (e) { /* leave defaults */ }
  }
  var VARIANTS = DATA.variants || [];
  var POS = DATA.optionPositions || { color: null, size: null };

  function variantById(id) {
    for (var i = 0; i < VARIANTS.length; i++) {
      if (String(VARIANTS[i].id) === String(id)) return VARIANTS[i];
    }
    return null;
  }

  var idInput = $('[data-variant-id]');
  var current = (idInput && variantById(idInput.value)) || VARIANTS[0] || null;

  var state = {
    img: 0,
    color: current && POS.color !== null ? current.options[POS.color] : null,
    size: current && POS.size !== null ? current.options[POS.size] : null,
    qty: 1
  };
  var isDesktop = window.matchMedia('(min-width: 1024px)');

  /* ============================================================
     Gallery
     ============================================================ */
  var film = $('[data-film]');
  var slides = $$('.gallery__slide', film);
  var thumbs = $$('[data-thumb]');
  var dotsWrap = $('[data-dots]');

  dotsWrap.innerHTML = slides.map(function (s, i) {
    return '<button type="button" data-dot="' + i + '" aria-pressed="' + (i === 0) + '" aria-label="Photo ' + (i + 1) + '"></button>';
  }).join('');
  var dots = $$('[data-dot]', dotsWrap);

  function setImage(i, scroll) {
    state.img = i;
    slides.forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
    thumbs.forEach(function (t, k) { t.setAttribute('aria-pressed', String(k === i)); });
    dots.forEach(function (d, k) { d.setAttribute('aria-pressed', String(k === i)); });
    if (scroll && !isDesktop.matches) {
      film.scrollTo({ left: film.clientWidth * i, behavior: 'smooth' });
    }
  }

  thumbs.forEach(function (t, i) {
    t.addEventListener('click', function () { setImage(i, true); });
  });
  dots.forEach(function (d, i) {
    d.addEventListener('click', function () { setImage(i, true); });
  });

  /* Mobile swipe: track the snapped slide */
  var scrollTick = false;
  film.addEventListener('scroll', function () {
    if (isDesktop.matches || scrollTick) return;
    scrollTick = true;
    requestAnimationFrame(function () {
      scrollTick = false;
      var i = Math.round(film.scrollLeft / film.clientWidth);
      if (i !== state.img && slides[i]) setImage(i, false);
    });
  }, { passive: true });

  /* Keyboard */
  main.addEventListener('keydown', function (e) {
    if (e.key === 'ArrowRight') { e.preventDefault(); setImage(Math.min(slides.length - 1, state.img + 1), true); }
    if (e.key === 'ArrowLeft') { e.preventDefault(); setImage(Math.max(0, state.img - 1), true); }
  });

  /* Zoom follows the cursor (desktop hover zoom) */
  main.addEventListener('mousemove', function (e) {
    if (!isDesktop.matches) return;
    var r = main.getBoundingClientRect();
    var img = slides[state.img].querySelector('img');
    img.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
  });

  /* Lightbox */
  var lightbox = $('#lightbox');
  main.addEventListener('click', function (e) {
    if (e.target.closest('button')) return; /* dots live inside the stage */
    var target = $('[data-lightbox-img]');
    if (!lightbox || !target) return;
    var img = slides[state.img] && slides[state.img].querySelector('img');
    if (!img) return;
    target.src = img.src;
    T.openDialog(lightbox);
  });
  main.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' || e.key === ' ') {
      if (e.target === main) { e.preventDefault(); main.click(); }
    }
  });

  /* ============================================================
     Variants — resolved against the real product
     ============================================================ */
  function matchVariant(color, size) {
    for (var i = 0; i < VARIANTS.length; i++) {
      var v = VARIANTS[i];
      if (POS.color !== null && color !== null && v.options[POS.color] !== color) continue;
      if (POS.size !== null && size !== null && v.options[POS.size] !== size) continue;
      return v;
    }
    return null;
  }

  function firstAvailableForColor(color) {
    for (var i = 0; i < VARIANTS.length; i++) {
      var v = VARIANTS[i];
      if (POS.color !== null && v.options[POS.color] !== color) continue;
      if (v.available) return v;
    }
    return matchVariant(color, null);
  }

  function setText(sel, value) {
    $$(sel).forEach(function (el) { el.textContent = value; });
  }

  function syncSizeAvailability() {
    if (POS.size === null) return;
    $$('.buybox__sizes [data-size]').forEach(function (btn) {
      var v = matchVariant(state.color, btn.getAttribute('data-size'));
      btn.disabled = !(v && v.available);
      if (v && v.tracked) {
        btn.setAttribute('data-stock', v.inventoryQuantity);
      } else {
        btn.removeAttribute('data-stock');
      }
    });
  }

  function syncPrice(v) {
    if (!v) return;
    setText('[data-price]', T.formatMoney(v.price));

    var onSale = v.compareAtPrice > v.price;
    $$('[data-compare]').forEach(function (el) {
      el.hidden = !onSale;
      el.textContent = onSale ? T.formatMoney(v.compareAtPrice) : '';
    });
    $$('[data-save]').forEach(function (el) {
      el.hidden = !onSale;
      if (onSale) {
        var pct = Math.round((v.compareAtPrice - v.price) / v.compareAtPrice * 100);
        el.textContent = 'Save ' + pct + '%';
      }
    });
  }

  function syncStock(v) {
    var low = $('[data-low-stock]');
    if (!low) return;
    var show = !!(v && v.tracked && v.inventoryQuantity > 0 && v.inventoryQuantity <= (DATA.lowStockThreshold || 5));
    low.hidden = !show;
    if (show) setText('[data-stock-left]', v.inventoryQuantity);
  }

  function syncAvailability(v) {
    $$('[data-atc]').forEach(function (b) {
      var sold = !(v && v.available);
      b.disabled = sold;
      if (!b.classList.contains('is-added')) {
        b.textContent = sold ? 'Sold out' : 'Add to Cart';
      }
    });
  }

  function syncGallery(v) {
    if (!v || !v.mediaPosition) return;
    var slide = $('[data-media-position="' + v.mediaPosition + '"]');
    if (!slide) return;
    var index = slides.indexOf(slide);
    if (index > -1 && index !== state.img) setImage(index, true);
  }

  function syncBarImage(v) {
    if (!v || !v.mediaPosition) return;
    var slide = $('[data-media-position="' + v.mediaPosition + '"]');
    var source = slide && slide.querySelector('img');
    if (!source) return;
    $$('[data-variant-image]').forEach(function (img) { img.src = source.src; });
  }

  function syncFbtSelf(v) {
    if (!v) return;
    var self = $('.fbt-item[disabled]');
    if (!self) return;
    self.setAttribute('data-fbt', v.price);
    self.setAttribute('data-fbt-compare', Math.max(v.compareAtPrice || 0, v.price));
    self.setAttribute('data-fbt-variant', v.id);
    var priceEl = self.querySelector('.fbt-item__price');
    if (priceEl) priceEl.textContent = T.formatMoney(v.price);
    if (typeof fbtSync === 'function') fbtSync();
  }

  function syncUrl(v) {
    if (!v || !window.history || !window.history.replaceState) return;
    var url = new URL(window.location.href);
    url.searchParams.set('variant', v.id);
    window.history.replaceState({}, '', url.toString());
  }

  function selectVariant(v) {
    if (!v) return;
    current = v;
    if (POS.color !== null) state.color = v.options[POS.color];
    if (POS.size !== null) state.size = v.options[POS.size];

    if (idInput) idInput.value = v.id;

    $$('.buybox__swatches [data-color]').forEach(function (b) {
      b.setAttribute('aria-pressed', String(b.getAttribute('data-color') === state.color));
    });
    $$('.buybox__sizes [data-size]').forEach(function (b) {
      b.setAttribute('aria-pressed', String(b.getAttribute('data-size') === state.size));
    });

    syncSizeAvailability();
    syncPrice(v);
    syncStock(v);
    syncAvailability(v);
    syncGallery(v);
    syncBarImage(v);
    syncFbtSelf(v);
    syncUrl(v);
    syncSelection();
    syncQty();
  }

  function syncSelection() {
    if (state.color !== null) setText('[data-sel-color]', state.color);
    if (state.size !== null) setText('[data-sel-size]', state.size);

    $$('[data-sel-separator]').forEach(function (el) {
      el.hidden = !(state.color !== null && state.size !== null);
    });

    /* highlight the matching row in every size table */
    $$('[data-size-table]').forEach(function (table) {
      var rowsList = $$('tr[data-age]', table);

      /* Age charts (0–3M, 3–6M…) won't match clothing sizes like S/M/L/XL — in that
         case leave the server-rendered default highlight and badge exactly as they are. */
      var anyMatch = rowsList.some(function (row) {
        return state.size !== null && row.getAttribute('data-age') === state.size;
      });
      if (!anyMatch) return;

      rowsList.forEach(function (row) {
        var sel = row.getAttribute('data-age') === state.size;
        row.classList.toggle('is-selected', sel);
        var cell = row.cells[0];
        var chip = cell.querySelector('.your-pick');
        if (sel && !chip) cell.insertAdjacentHTML('beforeend', '<span class="your-pick">Your pick</span>');
        if (!sel && chip) chip.remove();
      });
    });
  }

  $$('.buybox__swatches [data-color]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var color = btn.getAttribute('data-color');
      var v = matchVariant(color, state.size);
      if (!v || !v.available) v = firstAvailableForColor(color);
      selectVariant(v);
    });
  });

  $$('.buybox__sizes [data-size]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (btn.disabled) return;
      selectVariant(matchVariant(state.color, btn.getAttribute('data-size')));
    });
  });

  /* ============================================================
     Quantity + live total
     ============================================================ */
  var qtyOut = $('[data-qty]');
  var qtyInput = $('[data-qty-input]');
  function syncQty() {
    if (qtyOut) qtyOut.textContent = state.qty;
    if (qtyInput) qtyInput.value = state.qty;
    var totalEl = $('[data-total]');
    if (totalEl && current) totalEl.textContent = T.formatMoney(current.price * state.qty);
  }
  var qtyInc = $('[data-qty-inc]');
  var qtyDec = $('[data-qty-dec]');
  if (qtyInc) qtyInc.addEventListener('click', function () { state.qty = Math.min(99, state.qty + 1); syncQty(); });
  if (qtyDec) qtyDec.addEventListener('click', function () { state.qty = Math.max(1, state.qty - 1); syncQty(); });

  /* ============================================================
     Add to cart — real cart POST, button morphs to a checkmark
     ============================================================ */
  var atcTimer = null;
  var buyForm = $('#buybox-form');

  function doAdd() {
    if (!current || !current.available) return;

    T.addToCart(current.id, state.qty, { openDrawer: true });
    T.sparkleBurst($('.atc-wrap .sparkle-host'), 9);

    $$('[data-atc]').forEach(function (b) {
      b.classList.add('is-added');
      b.textContent = '✓ Added to cart';
    });
    clearTimeout(atcTimer);
    atcTimer = window.setTimeout(function () {
      $$('[data-atc]').forEach(function (b) {
        b.classList.remove('is-added');
        b.textContent = current && current.available ? 'Add to Cart' : 'Sold out';
      });
    }, 2000);
  }

  if (buyForm) {
    buyForm.addEventListener('submit', function (e) {
      e.preventDefault();
      doAdd();
    });
  }

  $$('[data-atc]').forEach(function (b) {
    if (buyForm && buyForm.contains(b)) return;
    b.addEventListener('click', function (e) { e.preventDefault(); doAdd(); });
  });

  /* Paint everything from the variant the page opened on. */
  selectVariant(current);

  /* ============================================================
     Sticky ATC bar (desktop) — appears when the buy box scrolls out
     ============================================================ */
  var stickyBar = $('[data-sticky-atc]');
  var sentinel = $('[data-buybox-sentinel]');
  if (stickyBar && sentinel && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      var e = entries[0];
      var show = !e.isIntersecting && e.boundingClientRect.top < 0;
      stickyBar.classList.toggle('is-visible', show);
      stickyBar.setAttribute('aria-hidden', String(!show));
    }, { threshold: 0 });
    io.observe(sentinel);
  }

  /* ============================================================
     Frequently bought together
     ============================================================ */
  var fbtWrap = $('.fbt');
  var fbtAdd = $('[data-fbt-add]');

  function fbtSync() {
    if (!fbtWrap) return;
    var selected = $$('[data-fbt][aria-pressed="true"]');

    var raw = selected.reduce(function (a, b) {
      return a + (parseInt(b.getAttribute('data-fbt'), 10) || 0);
    }, 0);
    var compare = selected.reduce(function (a, b) {
      var c = parseInt(b.getAttribute('data-fbt-compare'), 10) || 0;
      var p = parseInt(b.getAttribute('data-fbt'), 10) || 0;
      return a + Math.max(c, p);
    }, 0);

    var discount = parseFloat(fbtWrap.getAttribute('data-fbt-discount')) || 0;
    var now = Math.round(raw * (1 - discount / 100));
    var saving = compare - now;

    $$('[data-fbt-count]').forEach(function (el) { el.textContent = selected.length; });
    $$('[data-fbt-total]').forEach(function (el) { el.textContent = T.formatMoney(now); });

    $$('[data-fbt-was]').forEach(function (el) {
      el.hidden = saving <= 0;
      el.textContent = T.formatMoney(compare);
    });
    $$('[data-fbt-save-wrap]').forEach(function (el) { el.hidden = saving <= 0; });
    $$('[data-fbt-save]').forEach(function (el) { el.textContent = T.formatMoney(saving); });

    if (fbtAdd) fbtAdd.disabled = selected.length === 0;
  }

  function bindFbtButtons() {
    $$('[data-fbt]').forEach(function (btn) {
      if (btn._fbtBound) return;
      btn._fbtBound = true;
      btn.addEventListener('click', function () {
        if (btn.disabled) return;
        btn.setAttribute('aria-pressed', String(btn.getAttribute('aria-pressed') !== 'true'));
        fbtSync();
      });
    });
  }

  if (fbtWrap) {
    bindFbtButtons();
    if (fbtAdd) {
      fbtAdd.addEventListener('click', function () {
        var ids = $$('[data-fbt][aria-pressed="true"]').map(function (btn) {
          return btn.getAttribute('data-fbt-variant');
        });
        T.addItems(ids, { openDrawer: true });
      });
    }
    fbtSync();
  }

  /* ============================================================
     Review filters
     ============================================================ */
  function applyReviewFilter(mode) {
    $$('[data-review-filter]').forEach(function (b) {
      b.setAttribute('aria-pressed', String(b.getAttribute('data-review-filter') === mode));
    });
    var any = false;
    $$('[data-review-list] .pdp-review').forEach(function (card) {
      var show =
        mode === 'all' ||
        (mode === 'photos' && card.hasAttribute('data-photos')) ||
        card.getAttribute('data-stars') === mode;
      card.hidden = !show;
      if (show) any = true;
    });
    var empty = $('[data-review-empty]');
    if (empty) empty.hidden = any;
  }
  $$('[data-review-filter]').forEach(function (b) {
    b.addEventListener('click', function () { applyReviewFilter(b.getAttribute('data-review-filter')); });
  });
  $$('[data-bar-filter]').forEach(function (b) {
    b.addEventListener('click', function () { applyReviewFilter(b.getAttribute('data-bar-filter')); });
  });

  /* ============================================================
     Size guide modal
     ============================================================ */
  $$('[data-open-size-guide]').forEach(function (b) {
    b.addEventListener('click', function () {
      var modal = $('#size-modal');
      if (modal) T.openDialog(modal);
    });
  });

  /* ============================================================
     Delivery estimate — today + 2 days, e.g. "Sat, 5 Sep"
     ============================================================ */
  (function () {
    var el = $('[data-delivery-date]');
    if (!el) return;
    var d = new Date();
    d.setDate(d.getDate() + 2);
    var days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    el.textContent = days[d.getDay()] + ', ' + d.getDate() + ' ' + months[d.getMonth()];
  })();

  /* ============================================================
     Rails — arrows, and hiding them when there is nothing to scroll
     ============================================================ */
  function syncRailArrows(rail) {
    if (!rail) return;
    var row = document.querySelector('[data-rail-prev="' + rail.id + '"]');
    row = row && row.closest('.btn-row');
    if (!row) return;

    /* 2px tolerance: sub-pixel widths otherwise report a scrollable rail that isn't. */
    var canScroll = rail.scrollWidth > rail.clientWidth + 2;
    row.hidden = !canScroll;
    if (!canScroll) return;

    var prev = document.querySelector('[data-rail-prev="' + rail.id + '"]');
    var next = document.querySelector('[data-rail-next="' + rail.id + '"]');
    var max = rail.scrollWidth - rail.clientWidth;
    if (prev) prev.disabled = rail.scrollLeft <= 2;
    if (next) next.disabled = rail.scrollLeft >= max - 2;
  }

  function initRails(root) {
    $$('.hscroll[id]', root || document).forEach(function (rail) {
      syncRailArrows(rail);
      if (rail._railBound) return;
      rail._railBound = true;
      rail.addEventListener('scroll', function () { syncRailArrows(rail); }, { passive: true });
    });
  }

  initRails();
  window.addEventListener('resize', function () { initRails(); });

  /* Delegated so injected rails (related products) work without rebinding. */
  document.addEventListener('click', function (e) {
    var prev = e.target.closest('[data-rail-prev]');
    var next = e.target.closest('[data-rail-next]');
    if (!prev && !next) return;

    var btn = prev || next;
    var rail = document.getElementById(btn.getAttribute(prev ? 'data-rail-prev' : 'data-rail-next'));
    if (!rail) return;

    var card = rail.querySelector('.product-card');
    var step = card ? card.getBoundingClientRect().width + 20 : rail.clientWidth * 0.8;
    rail.scrollBy({ left: prev ? -step : step, behavior: 'smooth' });
  });

  /* ============================================================
     Related products — fetched from Shopify's recommendations
     ============================================================
     recommendations.performed is false on first paint, so the section renders empty and
     then replaces itself with the rendered version from the recommendations endpoint.
     ============================================================ */
  (function loadRelated() {
    var host = $('[data-related-recommendations]');
    if (!host) return;

    fetch(host.getAttribute('data-url'))
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-related-recommendations]');
        if (!fresh || !fresh.querySelector('.product-card')) {
          host.hidden = true;   /* no recommendations for this product */
          return;
        }
        host.innerHTML = fresh.innerHTML;
        requestAnimationFrame(function () { initRails(host); });
      })
      .catch(function () { host.hidden = true; });
  })();

  /* ---------- Init ---------- */
  syncSelection();
  syncQty();
})();